import gql from 'graphql-tag';

export const EditRoutineTemplate = gql`
	mutation EditRoutineTemplate(
		$pk: UUID!
		$category: String
		$checklistQuestions: [String]
		$description: String
		$excludeWeekends: Boolean
		$interval: Int
		$monthSetup: String
		$name: String
		$period: String
		$priority: Int
		$selectedDays: [String]
	) {
		editRoutineTemplate(
			pk: $pk
			category: $category
			checklistQuestions: $checklistQuestions
			description: $description
			excludeWeekends: $excludeWeekends
			interval: $interval
			monthSetup: $monthSetup
			name: $name
			period: $period
			priority: $priority
			selectedDays: $selectedDays
		) {
			success
		}
	}
`;

export const CreateRoutineTemplate = gql`
	mutation CreateRoutineTemplate(
		$category: String!
		$interval: Int!
		$name: String!
		$period: String!
		$priority: Int!
		$checklistQuestions: [String]
		$description: String
		$excludeWeekends: Boolean
		$monthSetup: String
		$selectedDays: [String]
	) {
		createRoutineTemplate(
			category: $category
			interval: $interval
			name: $name
			period: $period
			priority: $priority
			checklistQuestions: $checklistQuestions
			description: $description
			excludeWeekends: $excludeWeekends
			monthSetup: $monthSetup
			selectedDays: $selectedDays
		) {
			routineTemplate {
				id
			}
			success
		}
	}
`;

export const DeleteRoutineTemplate = gql`
	mutation DeleteRoutineTemplate($pk: UUID!) {
		deleteRoutineTemplate(pk: $pk) {
			success
		}
	}
`;
